import { HandoffMetric } from '../../../../handoff-hub.types';
import { ChecklistMetricItem } from '../handoff-checklist-v2/handoff-checklist-v2.types';
import {
  mapStatusToResult,
  mapResultToStatus,
  deriveOverallStatus,
  mapChecklistMetricsToHandoffMetrics,
  mapSnapshotMetricsToChecklist,
} from '../handoff-checklist-v2/handoff-checklist-v2.helpers';
import {
  VoiceAirReasonKey,
  REASON_MESSAGE_MAP as VOICE_AIR_REASON_MESSAGE_MAP,
} from '../voice-air-handoff/voice-air-handoff.helpers';
import { MESSAGING_AIR_METRIC_DEFINITIONS } from './messaging-air-metric-definitions';
import { MetricEvalContext } from './messaging-air-metrics.types';

export {
  mapStatusToResult,
  mapResultToStatus,
  deriveOverallStatus,
  mapChecklistMetricsToHandoffMetrics,
};

export type MessagingAirReasonKey =
  | VoiceAirReasonKey
  | 'messaging_air_customization_flags_active'
  | 'messaging_air_cf_active'
  | 'auto_missed_call_message_cf_active'
  | 'messaging_air_cf_inactive'
  | 'messaging_ai_tasks_reviewed'
  | 'messaging_ai_tasks_pending';

// Client-side reason-to-message mapping for the readonly snapshot view.
export const REASON_MESSAGE_MAP: Record<MessagingAirReasonKey, string> = {
  ...VOICE_AIR_REASON_MESSAGE_MAP,
  messaging_air_customization_flags_active:
    'Both "AI Messaging" and "Missed Call Text" flags are active.',
  messaging_air_cf_active: '"AI Messaging" customization flag is active.',
  auto_missed_call_message_cf_active: '"Missed Call Text" customization flag is active.',
  messaging_air_cf_inactive: '"AI Messaging" customization flag is not active.',
  messaging_ai_tasks_reviewed:
    'At least 3 messaging AI tasks were reviewed in the last 7 days.',
  messaging_ai_tasks_pending:
    'Fewer than 3 messaging AI tasks were reviewed in the last 7 days. Recent AI tasks may need review before handoff.',
};

export const mapSnapshotMetricsToMessagingAirChecklist = (
  metrics: HandoffMetric[],
  locationId: string
): ChecklistMetricItem[] =>
  mapSnapshotMetricsToChecklist(
    metrics,
    MESSAGING_AIR_METRIC_DEFINITIONS,
    (m, configCriterion) => {
      const reasonKey = m.actualValue as string;
      const resolvedWhereToFix = configCriterion?.whereToFix
        ? {
            label: configCriterion.whereToFix.label,
            url:
              typeof configCriterion.whereToFix.url === 'function'
                ? configCriterion.whereToFix.url({ locationId } as MetricEvalContext)
                : configCriterion.whereToFix.url,
          }
        : undefined;

      return {
        description: m.subsection,
        status: mapResultToStatus(m.result),
        reason: reasonKey,
        message:
          REASON_MESSAGE_MAP[reasonKey as MessagingAirReasonKey] ||
          reasonKey ||
          undefined,
        exception: m.exception,
        whereToFix: resolvedWhereToFix,
      };
    }
  );
